import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
const BOOK_CLUB_IDS = CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK_CLUB;
export const getSubscriptionProductTerms = (subscription) => {
    const termsComponent = subscription.product?.components?.find(({ componentId: id }) => id === BOOK_CLUB_IDS.TERMS_AND_CONDITIONS.ID);
    if (!termsComponent?.content) {
        return { minimum_orders: 0, binding_period_days: 0 };
    }
    if (termsComponent?.content?.__typename !== "ItemRelationsContent")
        throw new Error(`Terms is not of type item relations content - Sku ${subscription?.sku}`);
    if (termsComponent.content?.items?.length === 0 ||
        !termsComponent.content?.items) {
        return { minimum_orders: 0, binding_period_days: 0 };
    }
    const terms = termsComponent.content.items[0]?.components?.reduce((acc, component) => {
        // Find the obligations component (forpliktelser)
        if (component.componentId ===
            BOOK_CLUB_IDS.TERMS_AND_CONDITIONS.OBLIGATIONS.ID &&
            component.content?.__typename === "ContentChunkContent") {
            const bindingTimeComponent = component.content.chunks?.[0]?.[0];
            if (bindingTimeComponent?.componentId ===
                BOOK_CLUB_IDS.TERMS_AND_CONDITIONS.OBLIGATIONS.BINDING_PERIOD &&
                bindingTimeComponent?.content?.__typename === "NumericContent") {
                return {
                    ...acc,
                    binding_period_days: bindingTimeComponent.content.number,
                };
            }
        }
        return acc;
    }, { minimum_orders: 0, binding_period_days: 0 });
    return terms || { minimum_orders: 0, binding_period_days: 0 };
};
